import React from 'react'
import withView from '../../cmn/docAutomation/withView';
import InvBudgetBreakupRow from './InvBudgetBreakupRow'
import SarasTrans from '../../../library/notifications/SarasTrans'
import FormButton from '../../../library/form/components/FormActionButton2';
import FormROValue from '../../../library/form/components/FormROValue1';
import FormTitle from '../../../library/form/components/FormTitle'
import FormDialog from '../../../library/form/components/FormDialog';
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent } from "../../../library/layout/Index";

const InvBudgetBreakup = (props) => {
    const { formObject, viewData, ...restProps } = props;

    const renderHeading = () => {
        if(!showInPopup)
        {
            return(
                <UiTitle>
                    <FormTitle formObject={formObject} value="" />
                </UiTitle>
            )
        }
    }

    if (!viewData)
        return (null)

    const showInPopup = formObject.dataList.showInPopup === "1" ? true : false;

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={showInPopup}
            action={{ formActions: { forAction: "Close", forCancel: "" } }}
            formStyle={{ width: '950px' }}
            contentStyle={{ height: '400px' }}
            formTitle={<FormTitle formObject={formObject} value='Budget Breakup' />}
            formObject={formObject} >
            <UiView className="uiEditableContent">
                <UiViewHeading>
                    {
                        renderHeading()
                    }
                    <UiAction>
                        <FormButton formObject={formObject} rowKey="" className="uiActionButton"
                            action={{ actionId: "new",  actionParam: {}, containerKey: "row" }}
                            text={<SarasTrans value="Add Record" />}>
                        </FormButton>
                    </UiAction>
                </UiViewHeading>
                <UiViewContent>
                    <div>
                        <FormROValue format="#" formObject={formObject} headerKey="brkUpDtls" action={{ paramName: "itemName" }} className='uiVal' />
                        <FormROValue format="#" formObject={formObject} rowKey="budgetBrkUp" action={{ paramName: "itemNetAmt" }} className='uiVal uiSpacerL20' />
                        <FormROValue format="#" formObject={formObject} headerKey="brkUpDtls" action={{ paramName: "pendingPer" }} className='uiVal uiSpacerL20' />
                    </div>
                    <ul className="uiListTable">
                        <li className="uiSearchHeading">
                            <ul>
                                <li className="uiColumnCenter uiColumn70"><SarasTrans value="ID" /></li>
                                <li className="uiColumnCenter uiColumn200 "><SarasTrans value="Type" /></li>
                                <li className="uiColumnCenter uiColumn200 "><SarasTrans value="Cost Center" /></li>
                                <li className="uiColumnCenter uiColumn70"><SarasTrans value="Percent" /></li>
                                <li className="uiColumnCenter uiColumn150"><SarasTrans value="Amount" /></li>
                                <li className="uiColumnCenter uiColumn150"><SarasTrans value="Comment" /></li>
                                <li className="uiColumnCenter uiColumn70"><SarasTrans value="Action" /></li>
                            </ul>
                        </li>
                        {
                            Object.values(viewData).map((row, index) => (
                                row.rowKey !== "budgetBrkUp" ? (<InvBudgetBreakupRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} />) : ""
                            ))
                        }
                    </ul>
                </UiViewContent>
            </UiView>
        </FormDialog>
    )
}

export default withView(InvBudgetBreakup, "budgetBreakup", "itemDetail,invTrnFooter")